import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import Typewriter from 'typewriter-effect/dist/core';
import * as moment from 'moment';
declare let fbq: Function;
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { TiktokPixelService } from 'src/app/services/tiktok-pixel.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  vAprUrl = 'https://www.youtube.com/embed/d7NMQ82QVuM';
  safeURL: any;
  vAprUrl1 = 'https://www.youtube.com/embed/DHut3OGKOGM';
  safeURL1: any;
  app!: HTMLElement | null;
  year = moment().format('YYYY');
  typewriter: any;

  contatoTel: string = '5515988339053';
  contatoTelWhats: string = '(15)98833-9053';
  //5515988339053
  //5515991891604

  constructor(
    private router: Router,
    private _sanitizer: DomSanitizer,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private tiktokPixelService:TiktokPixelService
  ) {
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.vAprUrl);
    this.safeURL1 = this._sanitizer.bypassSecurityTrustResourceUrl(
      this.vAprUrl1
    );
    gsap.registerPlugin(ScrollTrigger);
    gsap.timeline({ paused: true });

    ScrollTrigger.defaults({
      markers:false
    })
  }

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = 'text/javascript';

    script.text = `
            {

    (function(n,r,l,d){try{var h=r.head||r.getElementsByTagName("head")[0],s=r.createElement("script");s.setAttribute("type","text/javascript");s.setAttribute("src",l);n.neuroleadId=d;h.appendChild(s);}catch(e){}})(window,document,"https://cdn.neurologic.com.br/neurolead/neurolead.min.js", 16437);
            }
        `;

    this._renderer2.appendChild(this._document.body, script);

    this.tiktokPixelService.tiktokViewContent();

    this.app = document.getElementById('tw');
    this.typewriter = new Typewriter(this.app, {
      loop: true,
      delay: 75,
    });


    this.typewriter
      .pauseFor(2000)
      .typeString('Hamburgueria')
      .pauseFor(500)
      .deleteChars(12)
      .typeString('Espetinhos')
      .pauseFor(500)
      .deleteChars(10)
      .typeString('Restaurante')
      .pauseFor(500)
      .deleteChars(11)
      .typeString('Marmitaria')
      .pauseFor(500)
      .deleteChars(10)
      .typeString('Pastelaria')
      .pauseFor(500)
      .deleteChars(10)
      .typeString('Sorveteria')
      .pauseFor(500)
      .deleteChars(10)
      .typeString('Açaiteria')
      .pauseFor(500)
      .start();


      /* gsap.from('#estabelecimento',{
        scrollTrigger: {
          trigger: '#beneficios',
          start: 'center 60%',
          end: 'top 300px',
          scrub: true,
          id:'estabelecimento',
        },
        opacity:0,
        x:-50,
        ease:'back',
        duration:2
      })

      gsap.from('#cliente ',{
        scrollTrigger: {
          trigger: '#cliente ',
          start: 'center 80%',
          end: 'top 300px',
          scrub: true,
          id:'cliente',
        },
        opacity:0,
        x:50,
        ease:'back',
        duration:2,
      })
 */
  }

  abreMenu() {
    let x: HTMLElement | null = document.getElementById('myLinks');

    if (x) {
      if (x.style.display === 'block') {
        x.style.display = 'none';
      } else {
        x.style.display = 'block';
      }
    }
  }

  mouseEnter(){
    console.log('mouseenter')
    gsap.timeline().to('#whatsCall',{
      scale:1.2,
      boxShadow:'0px 10px 20px rgba(37, 201, 111, 0.4)'
    })

  }

  mouseLeave(){
    console.log('mouseenter')
    gsap.timeline().to('#whatsCall',{
      scale:1,
      boxShadow:'none'
    })
  }
  textWhats() {
    window.open(
      `https://api.whatsapp.com/send?phone=${this.contatoTel}&text=Ol%C3%A1%2C%20tenho%20interesse%20em%20conhecer%20mais%20sobre%20o%20Yourder`,
      '_blank'
    );

    let hoje = moment().format('DD/MM/yyyy');
    fbq('track', 'Contact', hoje);

    this.tiktokPixelService.contactPixel();
  }

  scrollAssinaura() {
    const element = document.getElementById('assinaturaId');
    console.log(element);
    if (element) {
      element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  scrollGarantia() {
    const element = document.getElementById('garantiaId');
    console.log(element);
    if (element) {
      element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  scrollFuncoes() {
    const element = document.getElementById('FuncionalidadesId');
    console.log(element);
    if (element) {
      element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  scrollFAQ() {
    const element = document.getElementById('faqId');
    console.log(element);
    if (element) {
      element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  assinaturaPage() {
    this.router.navigateByUrl('assinatura/mensal');
  }
}
